import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Warning extends Component {
  static propTypes = {
    stepNumber: PropTypes.number,
    description: PropTypes.string,
    changeStep: PropTypes.func,
  };

  render() {
    return (
      <div className="ConfirmSetLive-Warning">
        <i className="fas fa-exclamation-triangle"></i> {this.props.description}{' '}
        <a onClick={() => this.props.changeStep(this.props.stepNumber)}>
          Jump to step {this.props.stepNumber}
        </a>
      </div>
    );
  }
}

export default Warning;
